/**
 * @module
 */

var _ = require('optimizely-client-fn');

var enums = require('core/constants/enums');


/**
 * Normalize clientData in-place to e.g. expand compact representations to more verbose representations
 * @param {Object} clientData
 */
exports.normalizeClientData = function(clientData:any) {
  // TODO(CJS-2060): remove fallback for listTargetingCookies
  if (!clientData.listTargetingKeys && clientData.listTargetingCookies) {
    clientData.listTargetingKeys = _.map(clientData.listTargetingCookies, function(cookieName) {
      return {
        type: enums.ListTargetingKeyTypes.COOKIE,
        key: cookieName,
      };
    });
    delete clientData.listTargetingCookies;
  }
};
